define( [
	"./deletedIds"
], function( deletedIds ) {
	return deletedIds.slice;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/slice.js
// module id = 273
// module chunks = 1